// extracted by mini-css-extract-plugin
export default {"shimmer":"LogoutModal_shimmer__L7zYW","dark_shimmer":"LogoutModal_dark_shimmer__rVrGk","logout":"LogoutModal_logout__2lXcQ","action":"LogoutModal_action__neLJN"};